import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { loadEnglish } from '@/i18n/i18n'

export function Header() {
  const { t, i18n } = useTranslation()
  const currentLang = i18n.language
  const { pathname } = useLocation()

  const navLinks = (
    <>
      <Link
        to="/"
        className={`text-sm px-3 py-1.5 rounded-md transition-colors whitespace-nowrap shrink-0 ${
          pathname === '/'
            ? 'text-foreground font-semibold bg-muted'
            : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        {t('nav.calculator')}
      </Link>
      <Link
        to="/blog"
        className={`text-sm px-3 py-1.5 rounded-md transition-colors whitespace-nowrap shrink-0 ${
          pathname.startsWith('/blog')
            ? 'text-foreground font-semibold bg-muted'
            : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        {t('nav.blog')}
      </Link>
      <Link
        to="/widget-hipoteczny"
        className={`text-sm px-3 py-1.5 rounded-md transition-colors whitespace-nowrap shrink-0 ${
          pathname.startsWith('/widget-hipoteczny')
            ? 'text-foreground font-semibold bg-muted'
            : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        {t('nav.embed')}
      </Link>
    </>
  )

  return (
    <header className="bg-white/80 backdrop-blur-md sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4 py-3 sm:py-4">
        <div className="flex items-center justify-between gap-3">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity shrink-0">
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#6366f1] to-[#8b5cf6] flex items-center justify-center shadow-lg shadow-indigo-500/30 p-1.5">
              <svg viewBox="0 0 32 32" fill="none" className="w-full h-full">
                <rect x="9" y="16" width="10" height="9" rx="1" fill="white" opacity="0.95"/>
                <path d="M7 17L14 10.5L21 17" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                <rect x="12.5" y="20" width="3" height="5" rx="0.8" fill="#8b5cf6" opacity="0.6"/>
                <rect x="10.5" y="17.5" width="2.5" height="2" rx="0.5" fill="#8b5cf6" opacity="0.4"/>
                <rect x="24" y="21" width="1.5" height="4" rx="0.5" fill="white" opacity="0.7"/>
                <ellipse cx="24.75" cy="18.5" rx="3" ry="4" fill="white" opacity="0.85"/>
              </svg>
            </div>
            <div className="hidden sm:block">
              <p className="text-lg font-bold text-foreground leading-tight">
                {t('app.title')}
              </p>
              <p className="text-xs text-muted-foreground">{t('app.subtitle')}</p>
            </div>
          </Link>
          <nav className="hidden md:flex items-center gap-1 ml-2 mr-auto">
            {navLinks}
          </nav>
          <div className="flex items-center gap-1 bg-muted rounded-lg p-1 shrink-0">
            <Button
              variant={currentLang === 'pl' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => i18n.changeLanguage('pl')}
              className="text-xs px-3 h-7"
            >
              {t('language.pl')}
            </Button>
            <Button
              variant={currentLang === 'en' ? 'default' : 'ghost'}
              size="sm"
              onClick={async () => { await loadEnglish(); i18n.changeLanguage('en') }}
              className="text-xs px-3 h-7"
            >
              {t('language.en')}
            </Button>
          </div>
        </div>
        <nav className="md:hidden flex items-center gap-1 mt-2 -mx-4 px-4 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {navLinks}
        </nav>
      </div>
      <div className="h-px bg-gradient-to-r from-transparent via-indigo-500/30 to-transparent" />
    </header>
  )
}
